import { useEffect, useState } from 'react';
import { ReactComponent as Doc } from 'assets/icons/file.svg';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { ReactComponent as FileDownloadIcon } from 'assets/icons/file-download.svg';
import ButtonComponent from 'components/button/buttonComponent';
import { genericActionsIds } from 'utilities/constants';
import { useGetGenericActions } from 'hooks/useGetGenericActions';

export type FileItemType = {
  fileId?: string | null;
  name?: string;
  size?: string;
  url?: string;
  type?: string;
  originalFileType?: string;
};

interface FileItemProps {
  file: FileItemType;
  onDeleteFile?: () => void;
  onDownloadFile?: (url?: string, fileName?: string) => void;
  isEditMode?: boolean;
  encounterId?: string | null;
  disabled?: boolean;
}

export const FileItem = ({
  file,
  onDeleteFile,
  onDownloadFile,
  isEditMode = true,
  disabled = false,
}: FileItemProps) => {
  const [fileInfo, updateFileInfo] = useState(file);

  const { data } = useGetGenericActions({
    locale: 'en',
    genericActionId: [genericActionsIds.DOWNLOAD],
  });

  useEffect(() => {
    if (fileInfo) return;
    updateFileInfo(file);
  }, [file, fileInfo]);

  return (
    <div className="flex flex-col desktop:flex-row justify-between border border-gray-opacity-15 rounded-lg desktop:items-center w-full gap-2.5 py-2.5 px-5 desktop:px-30">
      <div className="flex items-center gap-2.5">
        <div className="text-med-gray-3">
          <Doc className={'w-6 h-6'} />
        </div>
        <div className="flex flex-col text-btn-black font-semibold">
          <div>{fileInfo.name}</div>
          <div className="text-med-gray-3 font-medium text-sm">
            {fileInfo.type?.toLowerCase()} • {fileInfo.size || '0 Kb'}
          </div>
        </div>
      </div>
      {isEditMode ? (
        <div onClick={onDeleteFile} className="cursor-pointer">
          <Close className={'w-5 h-5'} />
        </div>
      ) : (
        <div className="cursor-pointer">
          <ButtonComponent
            onClick={() =>
              onDownloadFile && onDownloadFile(fileInfo.url, file.name)
            }
            type={'outlined'}
            testID={'download-file-button'}
            Icon={FileDownloadIcon}
            iconHeight="w-[15px] h-[18px] cursor-pointer fill-current"
            iconPosition="left"
            className="flex items-center gap-2.5 !text-xs !w-auto"
            disabled={disabled}
          >
            <span>{data?.[genericActionsIds.DOWNLOAD]?.download}</span>
          </ButtonComponent>
        </div>
      )}
    </div>
  );
};
